import React from 'react';
import { Link } from 'react-router-dom';
import { TreePine, ArrowLeft } from 'lucide-react';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background">
      {/* Navigation */}
      <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-border">
        <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
          <Link to="/" className="flex items-center space-x-3">
            <TreePine className="w-8 h-8 text-primary" strokeWidth={1.5} />
            <h1 className="text-2xl font-serif font-semibold text-foreground">Sarmoh</h1>
          </Link>
          <Link to="/" className="text-primary hover:underline font-sans text-sm flex items-center">
            <ArrowLeft className="w-4 h-4 mr-1" /> Back to Home
          </Link>
        </div>
      </nav>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-4xl font-serif text-foreground mb-8">Terms & Conditions</h1>
        
        <div className="prose prose-gray max-w-none">
          <p className="text-foreground-muted mb-6">
            <strong>Last Updated:</strong> February 2026
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-serif text-foreground mb-4">1. Acceptance of Terms</h2>
            <p className="text-foreground-muted leading-relaxed">
              By accessing and using Sarmoh.in ("the Service"), operated by TLML Mediatech Pvt Ltd ("the Company"), 
              you agree to be bound by these Terms and Conditions. If you do not agree to these terms, 
              please do not use our Service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-serif text-foreground mb-4">2. Description of Service</h2>
            <p className="text-foreground-muted leading-relaxed">
              Sarmoh provides a platform for creating memorial tributes and family trees. Our services include:
            </p>
            <ul className="list-disc pl-6 mt-3 text-foreground-muted space-y-2">
              <li>Creating and sharing memorial tribute pages</li>
              <li>Building interactive family trees</li>
              <li>Collecting text and voice tributes from family and friends</li>
              <li>Generating shareable memorial cards</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-serif text-foreground mb-4">3. User Accounts</h2>
            <p className="text-foreground-muted leading-relaxed">
              To access certain features, you must create an account. You are responsible for maintaining 
              the confidentiality of your account credentials and for all activities under your account.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-serif text-foreground mb-4">4. User Content</h2>
            <p className="text-foreground-muted leading-relaxed">
              You retain ownership of content you upload to Sarmoh. By uploading content, you grant us 
              a non-exclusive license to use, display, and distribute that content within our Service. 
              You are solely responsible for the content you upload and must ensure it does not violate 
              any laws or third-party rights.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-serif text-foreground mb-4">5. Prohibited Conduct</h2>
            <p className="text-foreground-muted leading-relaxed">You agree not to:</p>
            <ul className="list-disc pl-6 mt-3 text-foreground-muted space-y-2">
              <li>Upload content that is defamatory, obscene, or illegal</li>
              <li>Impersonate any person or entity</li>
              <li>Interfere with the Service's operation</li>
              <li>Use the Service for unauthorized commercial purposes</li>
              <li>Violate any applicable laws or regulations</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-serif text-foreground mb-4">6. Intellectual Property</h2>
            <p className="text-foreground-muted leading-relaxed">
              The Sarmoh name, logo, and all related materials are trademarks of TLML Mediatech Pvt Ltd. 
              You may not use our trademarks without prior written consent.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-serif text-foreground mb-4">7. Limitation of Liability</h2>
            <p className="text-foreground-muted leading-relaxed">
              TLML Mediatech Pvt Ltd shall not be liable for any indirect, incidental, special, or 
              consequential damages arising from your use of the Service. Our total liability shall 
              not exceed the amount you paid for the Service in the preceding 12 months.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-serif text-foreground mb-4">8. Termination</h2>
            <p className="text-foreground-muted leading-relaxed">
              We reserve the right to suspend or terminate your account at any time for violation of 
              these Terms. Upon termination, your right to use the Service will immediately cease.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-serif text-foreground mb-4">9. Changes to Terms</h2>
            <p className="text-foreground-muted leading-relaxed">
              We may modify these Terms at any time. Continued use of the Service after changes 
              constitutes acceptance of the new Terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-serif text-foreground mb-4">10. Contact Information</h2>
            <p className="text-foreground-muted leading-relaxed">
              For questions about these Terms, please contact:<br />
              <strong>TLML Mediatech Pvt Ltd</strong><br />
              Email: legal@sarmoh.in
            </p>
          </section>
        </div>
      </div>

      {/* Footer */}
      <footer className="py-8 px-6 bg-paper border-t border-border">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-sm font-sans text-muted-foreground">
            © 2026 TLML Mediatech Pvt Ltd. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
